import { Module, Mutation, Action, VuexModule } from 'vuex-class-modules';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var _class, _class2, _temp;

function toArray(x) {
  if (x === undefined) {
    return undefined;
  }

  if (Array.isArray(x)) {
    return _toConsumableArray(x);
  }

  return [x];
}

var BreadcrumbsModule = Module(_class = (_class2 = (_temp =
/*#__PURE__*/
function (_VuexModule) {
  _inherits(BreadcrumbsModule, _VuexModule);

  function BreadcrumbsModule() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BreadcrumbsModule);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BreadcrumbsModule)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.breadcrumbs = [];
    _this.matched = [];
    _this.pendingBreadcrumbs = {};
    return _this;
  }

  _createClass(BreadcrumbsModule, [{
    key: "setInternalBreadcrumbs",
    value: function setInternalBreadcrumbs(matchedWithBreadcrumbs) {
      this.matched = matchedWithBreadcrumbs;
      this.breadcrumbs = matchedWithBreadcrumbs.filter(function (x) {
        return !!x.breadcrumbs;
      }).map(function (x) {
        return x.breadcrumbs;
      }).flat();
      this.pendingBreadcrumbs = {};
    }
  }, {
    key: "routeChanged",
    value: function routeChanged(route) {
      var _this2 = this;

      var matched = route.matched;

      if (matched.some(function (x) {
        return !x.instances["default"];
      })) {
        setTimeout(function () {
          _this2.routeChanged(route);
        }, 10);
      } else {
        var samePathLength = 0;

        for (; samePathLength < Math.min(matched.length, this.matched.length); samePathLength += 1) {
          if (matched[samePathLength].instances["default"] !== this.matched[samePathLength].instance) {
            break;
          }
        }

        var localMatched = this.matched.slice(0, samePathLength);

        if (matched.length > samePathLength) {
          matched.slice(samePathLength).forEach(function (routeMatchItem) {
            var instance = routeMatchItem.instances["default"];
            var pendingBreadcrumbs = _this2.pendingBreadcrumbs[instance._uid];
            var instanceBreadcrumbs = toArray(instance.breadcrumbs);
            var routeBreadcrumbs = toArray(routeMatchItem.meta.breadcrumbs);
            var bc = {
              instance: instance._uid,
              breadcrumbs: pendingBreadcrumbs || instanceBreadcrumbs || routeBreadcrumbs || []
            };
            localMatched.push(bc);
          });
        }

        this.setInternalBreadcrumbs(localMatched);
      }
    }
  }, {
    key: "setInternalInstanceBreadcrumbs",
    value: function setInternalInstanceBreadcrumbs(_ref) {
      var instance = _ref.instance,
          breadcrumbs = _ref.breadcrumbs;

      var matched = _toConsumableArray(this.matched);

      var found = matched.some(function (m) {
        if (m.instance === instance._uid) {
          m.breadcrumbs = toArray(breadcrumbs);
          return true;
        }

        return false;
      });

      if (found) {
        this.matched = matched;
        this.breadcrumbs = matched.filter(function (x) {
          return !!x.breadcrumbs;
        }).map(function (x) {
          return x.breadcrumbs;
        }).flat();
        this.pendingBreadcrumbs = {};
      } else {
        this.pendingBreadcrumbs[instance._uid] = toArray(breadcrumbs);
      }
    }
  }, {
    key: "setBreadcrumbs",
    value: function setBreadcrumbs(_ref2) {
      var instance = _ref2.instance,
          breadcrumbs = _ref2.breadcrumbs;
      this.setInternalInstanceBreadcrumbs({
        instance: instance,
        breadcrumbs: breadcrumbs
      });
    }
  }]);

  return BreadcrumbsModule;
}(VuexModule), _temp), (_applyDecoratedDescriptor(_class2.prototype, "setInternalBreadcrumbs", [Mutation], Object.getOwnPropertyDescriptor(_class2.prototype, "setInternalBreadcrumbs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "routeChanged", [Action], Object.getOwnPropertyDescriptor(_class2.prototype, "routeChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setInternalInstanceBreadcrumbs", [Mutation], Object.getOwnPropertyDescriptor(_class2.prototype, "setInternalInstanceBreadcrumbs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setBreadcrumbs", [Action], Object.getOwnPropertyDescriptor(_class2.prototype, "setBreadcrumbs"), _class2.prototype)), _class2)) || _class;

var BreadcrumbsModule$1 = {
  install: function install(Vue, _ref) {
    var store = _ref.store;
    Vue.prototype.breadcrumbs$ = new BreadcrumbsModule({
      store: store,
      name: 'breadcrumbs'
    });
  }
};

export default BreadcrumbsModule$1;
